/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Match_Reason_NoneInputs */

const cs_import_match_reason_none = /** @type {(inputs: Import_Match_Reason_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bez existující shody`)
};

const en_import_match_reason_none = /** @type {(inputs: Import_Match_Reason_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No existing match`)
};

/**
* | output |
* | --- |
* | "No existing match" |
*
* @param {Import_Match_Reason_NoneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_match_reason_none = /** @type {((inputs?: Import_Match_Reason_NoneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Match_Reason_NoneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_match_reason_none(inputs)
	return cs_import_match_reason_none(inputs)
});